import React from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import PrimaryButton from "../primary-button/primary-button.component";
import { scrollToSection } from "../../redux/nav/nav.actions";

import {
  FaEnvelope,
  FaFacebookSquare,
  FaInstagramSquare,
} from "react-icons/fa";

import "./footer.styles.scss";
import NavOptions from "../nav-options/nav-options.component";

const Footer: React.FC = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <div className="footer">
      <div className="footer-content">
        <PrimaryButton onClick={() => dispatch(scrollToSection("Contact"))}>
          {t("common.bookNow")}
        </PrimaryButton>
        <NavOptions vertical inverted show />
        <div className="icon-set">
          <a
            className="icon"
            href="https://www.instagram.com/toofareastbarber/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={t("footer.instagramAriaLabel")}
          >
            <FaInstagramSquare />
          </a>
          <a
            className="icon"
            href="https://www.facebook.com/toofareastbarber/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={t("footer.facebookAriaLabel")}
          >
            <FaFacebookSquare />
          </a>
          <a
            className="icon"
            href="mailto:info@toofareastbarber.com"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={t("footer.emailAriaLabel")}
          >
            <FaEnvelope />
          </a>
        </div>
      </div>

      <a
        href="https://bmacpherson.com"
        target="_blank"
        rel="noopener noreferrer"
        className="creator-link"
      >
        {t("footer.builtBy")}
      </a>
    </div>
  );
};

export default Footer;
